"use strict";
/* istanbul ignore file */
/// <reference path="./declarations.d.ts" />
Object.defineProperty(exports, "__esModule", { value: true });
exports.EPermissions = void 0;
const index_browser_1 = require("./xsrf/index.browser");
const silentLoginListener_1 = require("./silentLoginListener");
var rbac_1 = require("./dal/rbac");
Object.defineProperty(exports, "EPermissions", { enumerable: true, get: function () { return rbac_1.EPermissions; } });
exports.default = {
    XSRF_HEADER: index_browser_1.XSRF_HEADER,
    getXsrfCookieName: index_browser_1.getXsrfCookieName,
    // Exposes a utility function to add a listener for the successful silent login
    onSilentLogin: silentLoginListener_1.onSilentLogin,
};
